export default __webpack_public_path__ + "static/media/Excel-Logo.dca3fb65.svg";